module.exports = __webpack_public_path__ + "img/icon-commercial-use.153513e.svg";